import { Component, Inject, OnInit } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";;
import { SnackBarService } from '../../service/snack.bar.service';
import { GetLeadByContactIdGQL, GetUserDetailsGQL } from '../../../../generated/graphql';


export interface DialogData {
  contactId: string;
  sUserId: string;
}

@Component({
  selector: 'purchaser-dialog',
  templateUrl: 'purchaser-dialog.html',
})
export class PurchaserDialog implements OnInit {
  title: string;
  result: any;
  isCompany: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<PurchaserDialog>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private getUserDetailsGQL: GetUserDetailsGQL,
    private getLeadContactGQL : GetLeadByContactIdGQL,
    private snackBarSvc: SnackBarService,) {
    if (data.contactId) {
      this.title = "Lead Info"
    }
    else {
      this.title = "Sales Person Info"
    }
  }

  ngOnInit() {
    this.getInfo();
  }

  getInfo() {
    if (this.data.sUserId) {
      this.getUserDetailsGQL.fetch({ userId: this.data.sUserId })
        .subscribe((result) => {
          if (result?.errors) {
            this.snackBarSvc.showQueryError(result.errors);
          }
          this.result = result.data.getUserDetails;
        })
    }
    else {
      this.getLeadContactGQL.fetch({ contactId: this.data.contactId })
      .subscribe((result) => {
        if (result?.errors) {
          this.snackBarSvc.showQueryError(result.errors);
        }
        this.result = result.data.getLeadByContactId;
      })
    }

  }

  callTo(number) {
    if (!number) return;
    window.location.href = `tel:${number}`;
  }

  mailTo(email) {
    if (!email) return;
    window.location.href = `mailto:${email}`;
  }
}